module.exports = __webpack_public_path__ + "static/media/linkedin.56b93e75.svg";